import React, { useState } from "react";
import { Badge, Button, Form, Row } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import { dateTimeFormatter } from "../../../../global";
import {
  faKey,
  faPencil as PencilIcon,
  faTrash as DeleteIcon,
} from "@fortawesome/free-solid-svg-icons";
import FabPlateau from "../../../../components/UiComponents/Buttons/FabPlateau";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAccessSystems from "../hooks/useAccessSystems";
import useModal from "../../../../components/Modal/hooks/useModal";
import { showSuccessToast } from "../../../../components/Toasts";
import EditAccessSystemModal from "../EditAccessSystemModal";
import ConfirmDeleteDialog from "../../../../components/Modal/ConfirmDelete";
import IconButton from "../../../../components/IconButton";
import InfoModal from "../../../../components/Modal/Info";
import Table from "../../../../components/Tables/Table";

const columns = [
  { value: "name", name: "Name" },
  { value: "ip", name: "IP-Adresse" },
  { value: "mac", name: "MAC-Adresse" },
  { value: "is_online", name: "Online-Status" },
  { value: "last_online_at", name: "Letzter Online-Status" },
  { value: "options", name: "Optionen" },
];

const AccessSystemSection = () => {
  const { archive, accessSystems, loaded, fetchAccessSystems } =
    useAccessSystems();
  const { isShow: showArchive, toggle: toggleArchive } = useModal();
  const { isShow: showEdit, toggle: toggleEdit } = useModal();
  const { isShow: showApiKey, toggle: toggleApiKey } = useModal();
  const [selectedAccessSystem, setSelectedAccessSystem] = useState(null);
  const [apiKey, setApiKey] = useState();
  const handleEdited = (access_system) => {
    if (access_system.plain_api_key) {
      setApiKey(access_system.plain_api_key);
      toggleApiKey();
    }
    showSuccessToast();
    fetchAccessSystems();
  };

  const handleDelete = () => {
    archive(selectedAccessSystem);
    toggleArchive();
  };

  function handleEdit(accessSystem) {
    setSelectedAccessSystem(accessSystem);
    toggleEdit();
  }

  function handleArchive(accessSystem) {
    setSelectedAccessSystem(accessSystem);
    toggleArchive();
  }

  function handleCreate() {
    toggleEdit();
    setSelectedAccessSystem({});
  }

  return (
    <Card title={`Alle Geräte (${accessSystems.length ?? 0})`}>
      <div className="table-responsive">
        <div className="ui-table-container">
          <Table
            columns={columns}
            empty={loaded && accessSystems.length === 0}
            emptyMessage="Keine Geräte vorhanden"
            className="table table-bordered"
            id="dataTable"
            width="100%"
            cellSpacing="0"
          >
            {accessSystems &&
              accessSystems.map((access_system) => {
                return (
                  <tr key={access_system.id}>
                    <td>{access_system.name}</td>
                    <td>{access_system.ip}</td>
                    <td>{access_system.mac}</td>
                    <td>
                      {access_system.is_online ? (
                        <Badge pill variant="primary" text="light">
                          Online
                        </Badge>
                      ) : (
                        <Badge
                          className={"mr-2"}
                          pill
                          variant="danger"
                          text="light"
                        >
                          Offline
                        </Badge>
                      )}
                    </td>
                    <td>
                      {access_system.last_online_at
                        ? dateTimeFormatter(access_system.last_online_at)
                        : "Gerät noch nicht aktiviert"}
                    </td>
                    <td>
                      <IconButton
                        className="mr-1 bg-transparent border-0 mr-3"
                        textColor="var(--primary)"
                        icon={PencilIcon}
                        onClick={() => handleEdit(access_system)}
                      />
                      <IconButton
                        className="mr-2 mr-3 bg-transparent border-0"
                        textColor="var(--danger)"
                        icon={DeleteIcon}
                        onClick={() => handleArchive(access_system)}
                      />
                    </td>
                  </tr>
                );
              })}
          </Table>
        </div>
      </div>
      <Row className="justify-content-end mr-2 mt-5">
        <FabPlateau>
          <Button
            className="float-right p-2 pl-3 pr-3"
            variant="primary"
            onClick={handleCreate}
          >
            <FontAwesomeIcon icon={faKey} /> &nbsp;Zutrittssystem erstellen
          </Button>
        </FabPlateau>
      </Row>
      <EditAccessSystemModal
        show={showEdit}
        toggle={toggleEdit}
        access_system={selectedAccessSystem}
        handleSuccess={handleEdited}
      />
      <ConfirmDeleteDialog
        show={showArchive}
        handleClose={toggleArchive}
        handleDelete={handleDelete}
      />

      {showApiKey && (
        <InfoModal show={true} handleClose={toggleApiKey} title={"API KEY"}>
          <Form.Group className="mb-3">
            <Form.Label>API KEY</Form.Label>
            <Form.Control disabled={true} value={apiKey} />
            <Form.Text className="text-muted">
              Wichtig: Kopiere den API-Key jetzt! Er wird nach der Erstellung
              des Zugangssystems nicht mehr angezeigt.
            </Form.Text>
          </Form.Group>
        </InfoModal>
      )}
    </Card>
  );
};

export default AccessSystemSection;
